import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddSpecialisedEvent = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 19,
	viewBox: "0 0 21 19",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "red",
		fillRule: "nonzero",
		d: "M11.591 2.656c-.505-.875-1.677-.875-2.182 0L2.072 15.358c-.538.931.079 2.142 1.091 2.142h14.674c1.012 0 1.629-1.21 1.09-2.142zm.96-1.439 8.075 13.805c1.012 1.73-.148 3.978-2.052 3.978h-1.083v-1.5h-9V19H2.426C.522 19-.638 16.752.374 15.022L8.448 1.217c.95-1.623 3.154-1.623 4.104 0M12.51 11.74h1.004V19h-1.004zm-3.013 3.112h7v1h-7z"
	})
});
export default SvgAddSpecialisedEvent;
